import { useEffect, useState } from 'react';
import { fetchEvmTransaction } from '../api/transactions';

export function useEvmTransaction(hash, chain = null) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const normalized = String(hash || '').trim().toLowerCase();
    if (!/^0x[a-f0-9]{64}$/.test(normalized)) {
      setLoading(false);
      setError('Invalid transaction hash.');
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);
    setData(null);

    fetchEvmTransaction(normalized, chain)
      .then((result) => {
        if (!cancelled) {
          setData(result);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.response?.data?.message || err.message || 'Transaction not found.');
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [hash, chain]);

  return { data, loading, error, display: data?.display };
}
